import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from '@/shared/hooks/useUser';
import { LogoLoading } from '@/shared/ui/custom/logo-loading';
import { ServicesAnnouncementGate } from '@/features/services-announcement/ServicesAnnouncementGate';

const PrivateRoute = () => {
  const location = useLocation();
  const { user, loading, error } = useUser();
  
  // Show loading state while checking user
  if (loading) {
    return (
      <div className="min-h-dvh bg-background flex items-center justify-center">
        <LogoLoading 
          variant="breathing" 
          size="xl" 
          message="Checking authentication..." 
        />
      </div>
    );
  }

  // Handle errors or missing user data
  if (error || !user) {
    // Clear token if not already done
    localStorage.removeItem('token');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    // Each page owns its height. A 100vh wrapper extends below full-height
    // viewers when Safari's browser chrome reduces the visible viewport.
    <>
      <Outlet />
      <ServicesAnnouncementGate userId={user.id} prefersDark={user.prefers_dark} />
    </>
  );
};

export default PrivateRoute;
